<template>
    <div class="tab-pane fade show active text-center" v-if="! is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="!is_datas_ready">
        <span class="loaders">
        <img style="" src="https://user-images.githubusercontent.com/2493614/33472418-17bcab1a-d66a-11e7-9841-3f32d75307dd.gif"/>
        </span>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="inning.length == 0">
        <p>No scorecard data found.</p>
    </div>
    <div class="tab-pane fade show active" v-else>
        <div class="nav-tabs-wrap">
            <ul class="nav nav-tabs" role="tablist">

                <li v-for="(inning,index) in innings" :key="inning.order" role="tab">

                    <a :class="activeInningIndex == index ? 'active':''" style="cursor: pointer" @click=" activeInningIndex = index; matchScoreCardDetail(inning)">
                        {{ inning.caption }}
                </a>
            </li>
        </ul>
    </div>
    <div class="tab-content">
        <div class="tab-pane fade show active" id="match-inn-tab1" role="tabpanel" >
            <div class="table-responsive overflow-visible" v-if="inning.match && inning.match.battings">
                <div class="match-table extra">
                    <div class="thead">
                        <div class="table-row">
                            <div class="th">Batsman</div>
                            <div class="th">R</div>
                            <div class="th">B</div>
                            <div class="th">4s</div>
                            <div class="th">6s</div>
                            <div class="th">Sr</div>
                        </div>
                    </div>
                    <div class="table-body">
                        <div class="tbody">
                            <div class="table-row" :class="batting_player.type == 'Not Out' ? 'active-basement': ''" v-for="(batting_player,index) in inning.match.battings" :key="index">
                                 <div class="td">
                                    <a class="pointer">
                                     
                                   <span class="title d-none d-md-block" v-if="batting_player.balls!=0" @click="batsmanPopup(batting_player.player.slug,inning.match.slug,inning.order)" id="newId"><u>{{batting_player.player && batting_player.player.name ? batting_player.player.name : ''}}</u><i class="ico-bat ml-5" v-if="batting_player.active"></i></span>
                                   <span class="title d-none d-md-block" v-if="batting_player.balls==0" id="newId"><u>{{batting_player.player && batting_player.player.name ? batting_player.player.name : ''}}</u><i class="ico-bat ml-5" v-if="batting_player.active"></i></span>
                                    <span class="title d-md-none" v-if="batting_player.balls!=0" @click="batsmanPopup(batting_player.player.slug,inning.match.slug,inning.order)"><u>{{batting_player.player && batting_player.player.short_name ? batting_player.player.short_name : ''}}</u><i class="ico-bat ml-5" v-if="batting_player.active"></i></span>
                                     <span class="title d-md-none" v-if="batting_player.balls==0" ><u>{{batting_player.player && batting_player.player.short_name ? batting_player.player.short_name : ''}}</u><i class="ico-bat ml-5" v-if="batting_player.active"></i></span>
                                    </a>
                                    <!-- <BatsmanMiniStats class="position-3" @is_datas_ready="makeloaderfalse" @ShowBatsmanPopup="SetPopupfalse" v-if="batsman_slug==batting_player.player.slug" :match_slug='inning.match.slug' :batsman_slug='batting_player.player.slug' :inning_order='inning.order' v-show="ShowBatsmanPopup==true" :key="batting_player.id"/> -->

                                    <!-- // -->
                                    <span class="sub-title" v-if="batting_player.type == 'Retired hurt'">
                                        retired hurt
                                    </span>
                                    <span class="sub-title" v-else-if="batting_player.bowler || batting_player.fielder">
                                        {{ batting_player.type.startsWith('Catch OUT') ? 'c'
                                                 : batting_player.type == 'OUT stumped' ? 'st'
                                                 : batting_player.type.startsWith('Run OUT') ? 'r'
                                                 : batting_player.type.startsWith('Hit Wicket') ? 'hit wicket'
                                                 : batting_player.type == 'LBW' ? 'lbw' : '' }}
                                          {{ batting_player.type.includes("(sub)") ? 'sub':''}}  
                                        {{ batting_player.fielder.name || '' }}
                                        {{ batting_player.bowler ? `b ${batting_player.bowler.name}` : '' }}
                                    </span>
                                    <span class="sub-title" v-else>
                                        {{ batting_player.type }}
                                    </span>
                                </div>
                                <div class="td"><strong>{{batting_player.score}}</strong></div>
                                <div class="td">{{batting_player.balls}}</div>
                                <div class="td">{{batting_player.four}}</div>
                                <div class="td">{{batting_player.six}}</div>
                                <div class="td">{{batting_player.runrate}}</div>
                                <BatsmanMiniStats class="position-9999" @is_datas_ready="makeloaderfalse" @ShowBatsmanPopup="SetPopupfalse" v-if="batsman_slug==batting_player.player.slug" :match_slug='inning.match.slug' :batsman_slug='batting_player.player.slug' :inning_order='inning.order' v-show="ShowBatsmanPopup==true" :key="batting_player.id"/>
                            </div>
                            
                        </div>
                        
                        <div class="tfoot">
                            <div class="table-row">
                                <div class="td">Extras</div>
                                <div class="td text-lowercase">{{inning.sum ? inning.sum : '0'}} {{inning.bye ? 'b '+ inning.bye : 'b 0'}}, {{inning.legbye ? 'lb '+ inning.legbye : 'lb 0'}}, {{inning.noball ? 'nb '+ inning.noball : 'nb 0'}},{{inning.wide ? 'w '+ inning.wide : 'w 0'}}</div>
                            </div>
                            <div class="table-row">
                                <div class="td">Total</div>
                                <div class="td text-lowercase">{{inning.score}}/{{inning.wickets}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive overflow-visible" v-if="inning.match && inning.match.bowlings">
                <div class="match-table">
                    <div class="thead">
                        <div class="table-row">
                            <div class="th">Bowler</div>
                            <div class="th">{{ inning.match.matchtype == '100 Ball Match'? 'B' : 'O' }}</div>
                            <div class="th">M</div>
                            <div class="th">R</div>
                            <div class="th">W</div>
                            <div class="th">ER</div>
                        </div>
                    </div>
                    <div class="table-body">
                        <div class="tbody">
                            <div class="table-row" v-for="(bowling_player,index) in inning.match.bowlings" :key="index">
                                <div class="td">
                                    <a class="pointer" >
                                          <span class="title  d-none d-md-block" @click="bolwers(bowling_player.player.slug,inning.match.slug,inning.order)"><u>{{bowling_player.player && bowling_player.player.name ? bowling_player.player.name : ''}}</u></span>
                                         <span class="title d-md-none" @click="bolwers(bowling_player.player.slug,inning.match.slug,inning.order)"><u>{{bowling_player.player && bowling_player.player.short_name ? bowling_player.player.short_name : ''}}</u></span>
                                    </a>
                                </div>
                                <div class="td">{{bowling_player.overs}}</div>
                                <div class="td">{{bowling_player.mdns}}</div>
                                <div class="td">{{bowling_player.score}}</div>
                                <div class="td"><strong>{{bowling_player.wickets}}</strong></div>
                                <div class="td">{{bowling_player.runrate.toFixed(2)}}</div>
                                <BowlerMiniStats class="position-9999" @ShowBowlerPopup="SetBowerPopupfalse" v-if="bowler_slug==bowling_player.player.slug" :match_slug='inning.match.slug' :bowler_slug='bowling_player.player.slug' :inning_order='inning.order' v-show="ShowBowlerPopup==true" :key="bowling_player.id"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive" v-if="inning.match && inning.match.fallofwickets">
                <div class="match-table fall-wickets">
                    <div class="thead">
                        <div class="table-row">
                            <div class="th">Fall of wickets</div>
                            <div class="th">Score</div>
                            <div class="th">{{ inning.match.matchtype == '100 Ball Match'? 'Ball' : 'Over' }}</div>
                        </div>
                    </div>
                    <div class="table-body">
                        <div class="tbody">
                            <template v-for="(fallofwicket,index) in inning.match.fallofwickets">
                                <div class="table-row" v-if="fallofwicket.ball != 0" :key="index">
                                    <div class="td">
                                        <router-link :to="{ name: 'playerDetail.info', params:  { player: fallofwicket.player.slug} }">
                                            <span class="title d-none d-md-block"><u>{{fallofwicket.player && fallofwicket.player.name ? fallofwicket.player.name : ''}}</u></span>
                                            <span class="title d-md-none"><u>{{fallofwicket.player && fallofwicket.player.short_name ? fallofwicket.player.short_name : ''}}</u></span>
                                        </router-link>
                                    </div>
                                    <div class="td">{{fallofwicket.score}}</div>
                                    <div class="td">{{fallofwicket.ball}}</div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>
<script>
import moment from 'moment'
import axios from 'axios';
import BatsmanMiniStats from './BatsmanMiniStats.vue'
import BowlerMiniStats from './BowlerMiniStats.vue'
import $ from 'jquery'
    export default {
        name: 'Scorecard',
        components: {BatsmanMiniStats,BowlerMiniStats},
        data() {
            return {
                id:'',
                match:[],
                ShowBowlerPopup:false,
                bowler_slug:'',
                batsman_slug:'',
                ShowBatsmanPopup: false,
                innings: '',
                inning: [],
                activeInningIndex: 0,
                matchCurrentInning: 0,
                battings:[],
                bowlings:[],
                fallofwickets:[],
                players:[],
                matchCurrentInning: 0,
                bowler:'',
                player_slug:'',
                match_slug:''
            }
        },
        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return
                let persons = []
               this.players.forEach((element) => {
                persons.push(
                        {
                            "@type": "Person",
                            "name": element.player.name,
                            "alternateName": element.player.nick,
                            "address": element.player.birth_place,
                            "height": element.player.height,
                            "weight": element.player.weight,
                            "gender": element.player.gender,
                            "birthDate": moment(element.player.dob).format('YYYY-MM-DD HH:MM'),
                            "birthPlace": element.player.birth_place,
                            "description": "role "+element.player.role+ " "+ element.player.batting_style+" " + element.player.bowling_style+ " " + element.player.education,
                            "image": "https://planetcricket.com/public/images/logo1280x720.png"
                        }
                )
            });
                return {
                "@context": "http://schema.org",
                "@graph": persons
            }
        },

        metaInfo() {
            if (!Components['MatchDetail'])
                return
            let title = Components['MatchDetail'].setTitle() + "Scorecard - " + Components['MatchDetail'].match.team1.name + " VS " + Components['MatchDetail'].match.team2.name + " - Planet Cricket";
            let description = "Scorecard - " + Components['MatchDetail'].match.team1.name + " VS " + Components['MatchDetail'].match.team2.name + " - Planet Cricket";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        created()
        {
            if(! this.$route.query.player_stats && ! this.$route.query.match_slug && ! this.$route.query.inning_order && ! this.$route.query.type)
            {
               this.is_datas_ready=true;
            }
        },
        mounted()
        {

            if(this.$route.query.player_stats!="" && this.$route.query.match_slug!="" && this.$route.query.inning_order!="" && this.$route.query.type=="bowler")
            {
                this.main(this.$route.query.inning_order);
                this.is_datas_ready=true;
                this.bowler_slug=this.$route.query.player_stats;
                this.ShowBowlerPopup = true;
                // this.$router.push({ path: 'scorecard', query: { player_stats: this.$route.query.player_stats,match_slug:this.$route.query.match_slug,inning_order:this.$route.query.inning_order,type:'bowler' }});
            }
            else if(this.$route.query.player_stats!="" && this.$route.query.match_slug!="" && this.$route.query.inning_order!="" && this.$route.query.type=="batsman")
            {
                this.main(this.$route.query.inning_order);
                this.is_datas_ready=true;
                this.batsman_slug=this.$route.query.player_stats;
                this.ShowBatsmanPopup = true;
                // this.$router.push({ path: 'scorecard', query: { player_stats: this.$route.query.player_stats,match_slug:this.$route.query.match_slug,inning_order:this.$route.query.inning_order,type:'batsman' }});
            }
            else
            {
              this.main();
            }

            var _this = this;
            this.$root.$on('MatchUpdated', function (data) {
                if (Components['MatchDetail'] && data.match_id == Components['MatchDetail'].match.id && _this.activeInningIndex == _this.matchCurrentInning) {
                    _this.matchScoreCardDetail(_this.innings[_this.innings.length - 1],true)
                }
            });
        },
        beforeDestroy() {
            this.$root.$off('MatchUpdated')
        },

        methods: {
            makeloaderfalse()
            {
              this.is_datas_ready=false;
            },
            SetPopupfalse()
            {

              this.ShowBatsmanPopup = false;
              this.batsman_slug='';
            },
            SetBowerPopupfalse()
            {
               this.ShowBowlerPopup = false;
               this.bowler_slug='';
            },

            batsmanPopup(player_slug,match_slug,inning_order)
            {

                 this.batsman_slug=player_slug;
                  this.ShowBatsmanPopup = true;
                // this.$router.push({ path: 'scorecard', query: { player_stats: player_slug,match_slug:match_slug,inning_order:inning_order,type:'batsman' }});
            },

            bolwers(player_slug,match_slug,inning_order)
            {
                  this.bowler_slug=player_slug;
                  this.ShowBowlerPopup = true;
                // this.$router.push({ path: 'scorecard', query: { player_stats: player_slug,match_slug:match_slug,inning_order:inning_order,type:'bowler' }});
            },
            main(InningId) {
                    if(typeof(InningId) !== 'undefined')
                    {
                        if(InningId!='')
                        {
                          this.innings = Components['MatchDetail'].match.innings;
                          this.matchCurrentInning = this.activeInningIndex = InningId-1;
                          return this.matchScoreCardDetail(this.innings[InningId-1]);
                        }
                        else
                        {
                              this.is_data_ready = true
                        }
                    }
                    else
                    {
                       this.innings = Components['MatchDetail'].match.innings;
                        if(this.innings[0] && this.innings[0].order)
                        {
                            this.matchCurrentInning = this.activeInningIndex = this.innings.length-1;
                           return this.matchScoreCardDetail(this.innings[this.innings.length-1]);
                        }
                        else
                        {
                           this.is_data_ready = true
                        }

                    }
            },
            matchScoreCardDetail(inning,cacheBust = false) {
                if (inning.order && inning.team_id) {
                    return this.$axios
                            .get(this.$MATCH_SCORECARD_API.replace(':match', this.$route.params.match), {
                                params: {
                                    inning: inning.order,
                                    team: inning.team_id,
                                    ttl: 0,
                                    ...(cacheBust && {cacheBust: Math.ceil(new Date().getTime() / 1000)})
                                }
                            })
                            .then(response => {
                                this.is_data_ready = true
                                //this.is_datas_ready=true;
                                this.inning = response.data.result.inning || []

                                this.battings = this.inning.match.battings
                                this.bowlings = this.inning.match.bowlings
                                this.fallofwickets = this.inning.match.fallofwickets
                                this.players = [...this.battings,...this.bowlings,...this.fallofwickets]
                            })
                            .catch(error => {
                                console.log(error);
                                this.is_data_ready = true
                            })
                }
            }
        },

    }
</script>
<style lang="scss">
@media (min-width: 576px){
    .loaders img{
height: auto; max-width: 10%;
}
.stats-modal .match-table .td:nth-child(2),
.stats-modal .match-table .td:nth-child(3),
.stats-modal .match-table .td:nth-child(4),
.stats-modal .match-table .td:nth-child(5),
.stats-modal .match-table .td:nth-child(7),
.stats-modal .match-table .th:nth-child(2),
.stats-modal .match-table .th:nth-child(3),
.stats-modal .match-table .th:nth-child(4),
.stats-modal .match-table .th:nth-child(5),
.stats-modal .match-table .th:nth-child(7) {
    width: 38px;
}
}
.loaders
{
    position: fixed;
    left: 0;
    width: 100%;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,.7);
    z-index: 5;
}
.loaders img{
height: auto; max-width: 5%;
}
</style>
